export const isPurePartNumberQuery = (text = "") => {
  const compact = String(text || "").trim().replace(/\s+/g, "");
  return (
    /[A-Za-z]/.test(compact) &&
    /\d/.test(compact) &&
    /^[A-Za-z0-9][A-Za-z0-9._/:-]{2,127}$/.test(compact)
  );
};

export const shouldRequestWebSearch = ({
  hasChipImageAttachments = false,
  text = "",
} = {}) => {
  if (hasChipImageAttachments || isPurePartNumberQuery(text)) return true;
  if (/联网|搜索|最新/.test(String(text))) return true;
  const tokens = String(text).match(/[A-Za-z0-9][A-Za-z0-9._/:-]{5,127}/g) || [];
  return tokens.some(isPurePartNumberQuery);
};
